/**
 * Route for `igaming-self-excluded-player-filter-never-credit-a`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingSelfExcludedPlayerFilterNeverCreditAPage } from "../features/igaming-self-excluded-player-filter-never-credit-a/IgamingSelfExcludedPlayerFilterNeverCreditAPage";

export const igamingSelfExcludedPlayerFilterNeverCreditARoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-self-excluded-player-filter-never-credit-a",
	component: IgamingSelfExcludedPlayerFilterNeverCreditAPage,
});

export default igamingSelfExcludedPlayerFilterNeverCreditARoute;
